import React from 'react';
import { ImageIcon, FileText, Paperclip } from 'lucide-react';

export const FileIcon = ({ attachmentUrl }) => {
    if (!attachmentUrl) return null;
    const extension = attachmentUrl.split('.').pop().toLowerCase().split('?')[0];
    
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
        return <ImageIcon size={18} className="text-green-600" />;
    }
    if (['pdf'].includes(extension)) {
        return <FileText size={18} className="text-red-600" />;
    }
    if (['doc', 'docx'].includes(extension)) {
        return <FileText size={18} className="text-blue-600" />;
    }
    return <Paperclip size={18} className="text-gray-500" />;
};